import deep from 'deep-get-set';
import { createSelector } from 'reselect';
import Immutable from "immutable";
import { push } from 'react-router-redux';
import { getCampaigns } from "./campaign";
import { getVideos } from "./video";
import { getTags } from "./tag";
import { getPluginsByUserId } from "./plugins";
import {
  accountStats,
  getVideosByMonth,
  getVideosViewsAndPlaysCount,
  getVideoStats,
  getCampaignStats,
} from './insight';

const LOAD_OWNED = "organization/LOAD_OWNED";
const LOAD_OWNED_SUCCESS = "organization/LOAD_OWNED_SUCCESS";
const LOAD_OWNED_FAIL = "organization/LOAD_OWNED_FAIL";
const LOAD_ORGANIZATION_MEMBERS = "organization/LOAD_ORGANIZATION_MEMBERS";
const LOAD_ORGANIZATION_MEMBERS_SUCCESS =
  "organization/LOAD_ORGANIZATION_MEMBERS_SUCCESS";
const LOAD_ORGANIZATION_MEMBERS_FAIL =
  "organization/LOAD_ORGANIZATION_MEMBERS_FAIL";
const LOAD_MEMBER = "organization/LOAD_MEMBER";
const LOAD_MEMBER_SUCCESS = "organization/LOAD_MEMBER_SUCCESS";
const LOAD_MEMBER_FAIL = "organization/LOAD_MEMBER_FAIL";
const LOAD_SELECT = "organization/LOAD_SELECT";
const LOAD_SELECT_SUCCESS = "organization/LOAD_SELECT_SUCCESS";
const LOAD_SELECT_FAIL = "organization/LOAD_SELECT_FAIL";
const LOAD_CREATE = "organization/LOAD_CREATE";
const LOAD_CREATE_SUCCESS = "organization/LOAD_CREATE_SUCCESS";
const LOAD_CREATE_FAIL = "organization/LOAD_CREATE_FAIL";
const LOAD_UPDATE = "organization/LOAD_UPDATE";
const LOAD_UPDATE_SUCCESS = "organization/LOAD_UPDATE_SUCCESS";
const LOAD_UPDATE_FAIL = "organization/LOAD_UPDATE_FAIL";
const LOAD_INVITE_MEMBERS = "organization/LOAD_INVITE_MEMBERS";
const LOAD_INVITE_MEMBERS_SUCCESS = "organization/LOAD_INVITE_MEMBERS_SUCCESS";
const LOAD_INVITE_MEMBERS_FAIL = "organization/LOAD_INVITE_MEMBERS_FAIL";
const LOAD_ROLES = "organization/LOAD_ROLES";
const LOAD_ROLES_SUCCESS = "organization/LOAD_ROLES_SUCCESS";
const LOAD_ROLES_FAIL = "organization/LOAD_ROLES_FAIL";
const LOAD_DELETE_MEMBERS = "organization/LOAD_DELETE_MEMBERS";
const LOAD_DELETE_MEMBERS_SUCCESS = "organization/LOAD_DELETE_MEMBERS_SUCCESS";
const LOAD_DELETE_MEMBERS_FAIL = "organization/LOAD_DELETE_MEMBERS_FAIL";
const LOAD_UPDATE_MEMBER = "organization/LOAD_UPDATE_MEMBER";
const LOAD_UPDATE_MEMBER_SUCCESS = "organization/LOAD_UPDATE_MEMBER_SUCCESS";
const LOAD_UPDATE_MEMBER_FAIL = "organization/LOAD_UPDATE_MEMBER_FAIL";

export const ORGANIZATION_ID_HEADER = "Organization-Identification";
const previousOrganizationId = localStorage.getItem(ORGANIZATION_ID_HEADER);

const initialState = Immutable.fromJS({
  loading: false,
  errorMessage: null,
  ownedOrganization: {},
  ownedOrganizationMembers: [],
  selectedOrganizationId: previousOrganizationId || null,
  selectedOrganization: null,
  memberOrganizations: [],
  organizationRoles: [],
  loadingInvites: [],
  loadingDeletes: [],
  loadingMember: null,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_OWNED:
      return state.set("loading", true);

    case LOAD_OWNED_FAIL:
      return state.set("loading", false).set("errorMessage", action.payload);

    case LOAD_OWNED_SUCCESS:
      return state
        .set("loading", false)
        .set("errorMessage", false)
        .set("ownedOrganization", action.payload);

    case LOAD_ORGANIZATION_MEMBERS:
      return state.set("loading", true);

    case LOAD_ORGANIZATION_MEMBERS_FAIL:
      return state.set("loading", false).set("errorMessage", action.payload);

    case LOAD_ORGANIZATION_MEMBERS_SUCCESS:
      return state
        .set("loading", false)
        .set("errorMessage", false)
        .set("ownedOrganizationMembers", action.payload);

    case LOAD_MEMBER:
      return state.set("loading", true);

    case LOAD_MEMBER_FAIL:
      return state.set("loading", false).set("errorMessage", action.payload);

    case LOAD_MEMBER_SUCCESS:
      return state
        .set("loading", false)
        .set("errorMessage", false)
        .set("memberOrganizations", action.payload);

    case LOAD_SELECT:
      return state.set("loading", true);

    case LOAD_SELECT_FAIL:
      return state.set("loading", false)
        .set("errorMessage", action.payload);

    case LOAD_SELECT_SUCCESS:
      return state
        .set("loading", false)
        .set("errorMessage", false)
        .set("selectedOrganization", action.payload)
        .set("selectedOrganizationId", action.payload ? action.payload.id : null);

    case LOAD_CREATE:
      return state.set("loading", true);

    case LOAD_CREATE_FAIL:
      return state.set("loading", false).set("errorMessage", action.payload);

    case LOAD_CREATE_SUCCESS:
      return state
        .set("loading", false)
        .set("errorMessage", false)
        .set("ownedOrganization", action.payload);

    case LOAD_UPDATE:
      return state.set("loading", true);

    case LOAD_UPDATE_FAIL:
      return state.set("loading", false).set("errorMessage", action.payload);

    case LOAD_UPDATE_SUCCESS:
      return state
        .set("loading", false)
        .set("errorMessage", false)
        .set("ownedOrganization", action.payload);

    case LOAD_INVITE_MEMBERS:
      return state.set("loading", true).set("loadingInvites", action.payload);

    case LOAD_INVITE_MEMBERS_FAIL:
      return state
        .set("loading", false)
        .set("errorMessage", action.payload)
        .set("loadingInvites", []);

    case LOAD_INVITE_MEMBERS_SUCCESS:
      return state
        .set("loading", false)
        .set("errorMessage", false)
        .set("loadingInvites", []);

    case LOAD_ROLES:
      return state.set("loading", true);

    case LOAD_ROLES_FAIL:
      return state.set("loading", false).set("errorMessage", action.payload);

    case LOAD_ROLES_SUCCESS:
      return state
        .set("loading", false)
        .set("errorMessage", false)
        .set("organizationRoles", action.payload);

    case LOAD_DELETE_MEMBERS:
      return state.set("loading", true).set("loadingDeletes", action.payload);

    case LOAD_DELETE_MEMBERS_FAIL:
      return state
        .set("loading", false)
        .set("errorMessage", action.payload)
        .set("loadingDeletes", []);

    case LOAD_DELETE_MEMBERS_SUCCESS:
      return state
        .set("loading", false)
        .set("errorMessage", false)
        .set("loadingDeletes", []);

    case LOAD_UPDATE_MEMBER:
      return state.set("loading", true).set("loadingMember", action.payload);

    case LOAD_UPDATE_MEMBER_FAIL:
      return state
        .set("loading", false)
        .set("errorMessage", action.payload)
        .set("loadingMember", null);

    case LOAD_UPDATE_MEMBER_SUCCESS:
      return state
        .set("loading", false)
        .set("errorMessage", false)
        .set("loadingMember", null);

    default:
      return state;
  }
}

const getOrganizationById = (id, getState) => {
  const memberOrganizations = getState()
    .get("organization")
    .get("memberOrganizations");

  return id &&
    memberOrganizations.find(
      ({ organization }) => organization.id === id
    );
};

const getFirstAvailableOrganizationId = getState => {
  const memberOrganizations = getState()
    .get("organization")
    .get("memberOrganizations");

  const availableOrganizations = memberOrganizations
    .filter(({ organization }) => !organization.expired);

  return availableOrganizations.length ? availableOrganizations[0].organization.id : null;
}

/**
 * Selects context depending on previously selected context and db data
 */
export const selectDefaultContext = () => async (dispatch, getState, api) => {
  const user = getState().get("auth").get("user");
  let lastSelectedOrganizationId = user.selectedOrganizationId;

  const selectedOrganization = getOrganizationById(lastSelectedOrganizationId, getState);

  if (!selectedOrganization ||  selectedOrganization === null || selectedOrganization.organization.expired) {
    lastSelectedOrganizationId = null;

    if (user.expiredTrial) {
      lastSelectedOrganizationId = getFirstAvailableOrganizationId(getState);
      if (!lastSelectedOrganizationId) {
        dispatch(push('/billing'));
      }
    }
  }

  dispatch(selectOrganization(lastSelectedOrganizationId));
};

/**
 * Fetch all organization the user is owner
 */
export const getOwnedOrganization = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_OWNED });

  try {
    const response = await api.get(`/organizations/owner`);
    if (response.message) {
      dispatch({ type: LOAD_OWNED_FAIL, payload: response.message });
      return;
    }

    const organization = response.rows[0] || {};

    dispatch({ type: LOAD_OWNED_SUCCESS, payload: organization });
  } catch (error) {
    dispatch({ type: LOAD_OWNED_FAIL, payload: error });
  }
};

/**
 * Fetch all organizations the user is member
 */
export const getMemberOrganizations = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_MEMBER });

  try {
    const response = await api.get(`/organizations`);
    if (response.message) {
      dispatch({ type: LOAD_MEMBER_FAIL, payload: response.message });
      return;
    }

    dispatch({ type: LOAD_MEMBER_SUCCESS, payload: response.rows });

    dispatch(selectDefaultContext());
  } catch (error) {
    dispatch({ type: LOAD_MEMBER_FAIL, payload: error });
  }
};

/**
 * Select a organization that the user is member
 * @param {string} organizationId - Selected organization ID.
 * If is set to null will "unselect" the organization
 */
export const selectOrganization = (organizationId) => async (
  dispatch,
  getState,
  api
) => {
  dispatch({ type: LOAD_SELECT });

  const selectedOrganization = getOrganizationById(organizationId, getState);

  if (selectedOrganization === undefined) {
    dispatch({ type: LOAD_SELECT_FAIL, payload: "Organization not found" });
    return;
  }

  if (selectedOrganization && selectedOrganization.expired) {
    dispatch({ type: LOAD_SELECT_FAIL, payload: "Organization owner's free trial expired" });
    return;
  }

  const response = await api.patch('/organizations/select', { data: { organizationId }});
  if (response && response.message) {
    dispatch({ type: LOAD_SELECT_FAIL, payload: response.message });
    return;
  }

  dispatch({ type: LOAD_SELECT_SUCCESS, payload: selectedOrganization });

  localStorage.setItem(ORGANIZATION_ID_HEADER, organizationId);

  const user = getState()
    .get("auth")
    .get("user");

  dispatch(getCampaigns());
  dispatch(getTags());
  dispatch(getPluginsByUserId(user.id));
  // Insight page data reload
  dispatch(accountStats());
  dispatch(getVideosByMonth({ selectedDate: new Date() }));
  dispatch(getVideosViewsAndPlaysCount());
  dispatch(getVideoStats(1));
  dispatch(getCampaignStats(1));
};

/**
 * Create a new organization
 * @param {{ name: string }} organizationData
 * name: Organization name
 */
export const createOrganization = ({ name }) => async (
  dispatch,
  getState,
  api
) => {
  dispatch({ type: LOAD_CREATE });

  try {
    const response = await api.post(`/organizations`, {
      data: { name },
    });

    if (response.message) {
      dispatch({ type: LOAD_CREATE_FAIL, payload: response.message });
      return;
    }

    dispatch({ type: LOAD_CREATE_SUCCESS, payload: response });
  } catch (error) {
    dispatch({ type: LOAD_CREATE_FAIL, payload: error });
  }
};

/**
 * Update a existing organization
 * @param {object} organizationData
 * name: Organization name
 */
export const updateOrganization = ({ name }) => async (
  dispatch,
  getState,
  api
) => {
  dispatch({ type: LOAD_UPDATE });

  const ownedOrganization = getState()
    .get("organization")
    .get("ownedOrganization");

  try {
    const response = await api.put(`/organizations/${ownedOrganization.id}`, {
      data: { name },
    });

    if (response.message) {
      dispatch({ type: LOAD_UPDATE_FAIL, payload: response.message });
      return;
    }

    dispatch({ type: LOAD_UPDATE_SUCCESS, payload: response });
  } catch (error) {
    dispatch({ type: LOAD_UPDATE_FAIL, payload: error });
  }
};

/**
 * Invite new members to the organization
 * @param {array} members
 * List of users to be invited
 * [
 *  {
 *    email: string,
 *    roleId: uuid,
 *    all_campaigns_access: boolean,
 *    selected_campaigns?: [
 *      {
 *        id: number,
 *        roleId?: uuid
 *      }
 *    ]
 *  }
 * ]
 */
export const inviteMembers = (members = []) => async (
  dispatch,
  getState,
  api
) => {
  const loadingInvites = members.map(({ email }) => email);

  dispatch({ type: LOAD_INVITE_MEMBERS, payload: loadingInvites });

  const ownedOrganization = getState()
    .get("organization")
    .get("ownedOrganization");

  try {
    const response = await api.post(
      `/organizations/${ownedOrganization.id}/members`,
      {
        data: { members },
      }
    );

    if (response && response.message) {
      dispatch({ type: LOAD_INVITE_MEMBERS_FAIL, payload: response.message });
      return;
    }

    dispatch({ type: LOAD_INVITE_MEMBERS_SUCCESS });
    dispatch(listMembers());
  } catch (error) {
    dispatch({ type: LOAD_INVITE_MEMBERS_FAIL, payload: error });
  }
};

/**
 * Get organization member list
 */
export const listMembers = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_ORGANIZATION_MEMBERS });

  const ownedOrganization = getState()
    .get("organization")
    .get("ownedOrganization");

  try {
    const response = await api.get(
      `/organizations/${ownedOrganization.id}/members`
    );

    if (response.message) {
      dispatch({
        type: LOAD_ORGANIZATION_MEMBERS_FAIL,
        payload: response.message,
      });
      return;
    }

    dispatch({
      type: LOAD_ORGANIZATION_MEMBERS_SUCCESS,
      payload: response.rows,
    });
  } catch (error) {
    dispatch({ type: LOAD_ORGANIZATION_MEMBERS_FAIL, payload: error });
  }
};

/**
 * Update a member from the organization
 * @param {string} memberId
 * @param {object} toUpdate
 * {
 *   roleId?: uuid,
 *   all_campaigns_access?: boolean,
 *   selected_campaigns?: [
 *     {
 *       id: number,
 *       roleId?: uuid
 *     }
 *   ]
 * }
 */
export const updateMember = (memberId, toUpdate) => async (
  dispatch,
  getState,
  api
) => {
  dispatch({ type: LOAD_UPDATE_MEMBER, payload: memberId });

  const ownedOrganization = getState()
    .get("organization")
    .get("ownedOrganization");

  const members = getState()
    .get("organization")
    .get('ownedOrganizationMembers');

  try {
    const response = await api.put(
      `/organizations/${ownedOrganization.id}/members/${memberId}`,
      {
        data: toUpdate,
      }
    );

    if (response.message) {
      dispatch({
        type: LOAD_UPDATE_MEMBER_FAIL,
        payload: response.message,
      });
      return;
    }

    const updatedMember = response.rows[0];

    const updatedMemberList = members.map(member =>
      member.id === memberId ? updatedMember : member);

    dispatch({ type: LOAD_UPDATE_MEMBER_SUCCESS });
    dispatch({ type: LOAD_ORGANIZATION_MEMBERS_SUCCESS, payload: updatedMemberList });
  } catch (error) {
    dispatch({ type: LOAD_UPDATE_MEMBER_FAIL, payload: error });
  }
};

/**
 * Delete a member from the organization
 * @param {string} memberId
 */
export const deleteMember = (memberId) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_ORGANIZATION_MEMBERS });

  const ownedOrganization = getState()
    .get("organization")
    .get("ownedOrganization");

  try {
    const response = await api.del(
      `/organizations/${ownedOrganization.id}/members/${memberId}`
    );

    if (response && response.message) {
      dispatch({
        type: LOAD_ORGANIZATION_MEMBERS_FAIL,
        payload: response.message,
      });
      return;
    }

    dispatch(listMembers());
  } catch (error) {
    dispatch({ type: LOAD_ORGANIZATION_MEMBERS_FAIL, payload: error });
  }
};

/**
 * Delete a list of members from the organization
 * @param {string} memberId
 */
export const deleteMembers = memberlist => async (dispatch, getState, api) => {
  const idList = memberlist.map(({ id }) => ({ memberId: id }));

  dispatch({ type: LOAD_DELETE_MEMBERS, payload: idList });

  const ownedOrganization = getState()
    .get("organization")
    .get("ownedOrganization");

  try {
    const responses = await Promise.all(idList.map(({ memberId }) =>
      api.del(
        `/organizations/${ownedOrganization.id}/members/${memberId}`
      )
    ));

    const getMessage = response => response && response.message;
    if (responses.some(getMessage)) {
      const messages = responses.map(getMessage).filter((message) => !!message);

      dispatch({
        type: LOAD_DELETE_MEMBERS_FAIL,
        payload: messages,
      });
      return;
    }

    dispatch({ type: LOAD_DELETE_MEMBERS_SUCCESS });
    dispatch(listMembers());
  } catch (error) {
    dispatch({ type: LOAD_DELETE_MEMBERS_FAIL, payload: error });
  }
};

/**
 * Get organizations roles
 * @param {string} memberId
 */
export const getOrganizationRoles = (memberId) => async (
  dispatch,
  getState,
  api
) => {
  dispatch({ type: LOAD_ROLES });

  try {
    const response = await api.get("/organizations/roles");

    if (response.message) {
      dispatch({ type: LOAD_ROLES_FAIL, payload: response.message });
      return;
    }

    dispatch({ type: LOAD_ROLES_SUCCESS, payload: response.rows });
  } catch (error) {
    dispatch({ type: LOAD_ROLES_FAIL, payload: error });
  }
};

/**
 * Get org info with invite token
 * @param {string} inviteToken
 */
export const getOrganizationInfoWithInviteToken = ({ inviteToken, pending = false }) => async (
  dispatch,
  getState,
  api
) => {
  try {
    const response = await api.get(
      `/organizations?invite_token=${inviteToken}&pending=${pending}`
    );

    if (response.message) {
      return null;
    }

    return response;
  } catch (error) {
    return null;
  }
};

/**
 * Get org info with invite token
 * @param {string} inviteToken
 */
export const acceptOrganizationInvite = (inviteToken) => async (
  dispatch,
  getState,
  api
) => {
  try {
    await api.post(`/organizations/accept-invite`, { data: { inviteToken } });

    return;
  } catch (error) {
    return null;
  }
};

// Selectors
export const getOrganizationState = createSelector(
  state => state.get('organization'),
  organization => organization,
);

export const getSelectedOrganization = createSelector(
  getOrganizationState,
  organization => organization.get('selectedOrganization'),
);

export const getIsOrganizationAdmin = createSelector(
  getOrganizationState,
  getSelectedOrganization,
  (organization, selectedOrganization) => deep(selectedOrganization, 'role.name') === 'Admin'
  || organization.get('memberOrganizations').length === 0,
);



// WEBPACK FOOTER //
// ./src/redux/modules/organization.js